import { render, staticRenderFns } from "./DonationsAndResultsCard.vue?vue&type=template&id=007df7b6&"
import script from "./DonationsAndResultsCard.vue?vue&type=script&lang=js&"
export * from "./DonationsAndResultsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports